export default __webpack_public_path__ + "static/media/mars33.f58d7072.gif";